import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: "flagPipe2", standalone: true })
export class FlagPipe2 implements PipeTransform {
    transform(short_name: string): any {
        const str2 = `https://d3puay5pkxu9s4.cloudfront.net/icons/flags/4x3/${short_name.toLocaleLowerCase()}.svg`;
        return str2;
    }
}


@Pipe({ name: "formatPhoneNumber", standalone: false })
export class FormatPhoneNumber implements PipeTransform {
    transform(phone: any, code: any): any {

        let phone_number;
        if (code) {
            let country_code = code.replace(/-/g, '');
            phone_number = phone.split('+' + country_code)[phone.split('+' + country_code).length - 1];
        } else {
            phone_number = phone
        }

        return phone_number;
    }
}



@Pipe({ name: "sortByCode", standalone: false })
export class SortByCode implements PipeTransform {
    transform(array: any[], field?: any): any[] {
        array.sort(function (a, b) {
            return (parseInt(a.code) < parseInt(b.code)) ? -1 : (parseInt(a.code) > parseInt(b.code)) ? 1 : 0;
        });
        return array;
    }
}
